import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'BLOCK_CONTENTS_GET',
  GET_SUCCESS: 'BLOCK_CONTENTS_GET_SUCCESS',
  GET_FAILURE: 'BLOCK_CONTENTS_GET_FAILURE',
  INVALIDATE_ITEM: 'BLOCK_CONTENTS_INVALIDATE_ITEM',
  GET_ALL: 'BLOCK_CONTENTS_GET_ALL',
  GET_ALL_SUCCESS: 'BLOCK_CONTENTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'BLOCK_CONTENTS_GET_ALL_FAILURE',
};

export const get = actions.get(blockContentId => `${BASE_URL}/curriculum/block-contents/${blockContentId}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = id => (dispatch) => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/curriculum/block-contents/?${stringify(query)}`, {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
